import React from "react";

import { useAddToGoogleWalletContext } from "./AddToGoogleWalletContainer";

const AddToGoogleWallet = () => {
  const {
    addToGoogleWalletIconUrl,
    isLoading,
    error,
    downloadGoogleWalletPasses,
  } = useAddToGoogleWalletContext();

  const buttonStyle = {
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    width: "127px",
    height: "35px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    margin: "5px",
  };

  const errorStyle = {
    margin: "4px 5px 0",
    fontSize: "12px",
    color: "var(--setlist-error-700, #b42318)",
  };

  return (
    <>
      <button
        style={buttonStyle}
        onClick={downloadGoogleWalletPasses}
        disabled={isLoading}
      >
        {isLoading ? (
          <div>Adding to wallet</div>
        ) : (
          <img src={addToGoogleWalletIconUrl} alt="Add to Google Wallet" style={{ height: "35px" }} />
        )}
      </button>
      {error && <p role="alert" style={errorStyle}>{error}</p>}
    </>
  );
};

export default AddToGoogleWallet;
